import { useCallback } from 'react';
import { useRouter } from 'next/router';

import { routes } from 'constants/routes';
import { getQueryParam } from 'shared/utils/getQueryParam';

export const useNavigateToReturnUrl = () => {
  const router = useRouter();
  const returnUrl = getQueryParam(router.query, 'returnUrl', '' as string);

  return useCallback(() => {
    if (returnUrl.startsWith('/') && returnUrl.length > 1) {
      router.replace(returnUrl);
    } else if (returnUrl.startsWith('http')) {
      window.location.assign(returnUrl);
    } else {
      router.replace(routes.root);
    }
  }, [returnUrl, router]);
};
